import ConfigContext from './ConfigContext';

export * from './ConfigContext';
export { default as ConfigReducer } from './ConfigReducer';
export default ConfigContext;
